const e = /^[A-Za-z0-9_-]+$/;
function t(o) {
  return typeof o == "string" && o.length > 0 && e.test(o);
}
function r(o, n) {
  return `org:${o}:doc:${encodeURIComponent(n)}`;
}
export {
  r as e,
  t as i
};
//# sourceMappingURL=collabDocumentId-DMOnFNa-.js.map
